var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 35,
    viewBox: "0 0 51 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2003_216)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2003_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 31,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.13 0.182739H40.306V7.37601H10.13V0.182739Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2003_216)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2003_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 31,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5398 0.182739H36.9998C37.9025 0.182739 38.7708 0.560697 39.4109 1.23017C40.0492 1.90165 40.4095 2.81236 40.4095 3.75927C40.4095 4.70819 40.0492 5.61891 39.4109 6.28837C38.7708 6.95985 37.9025 7.3358 36.9998 7.3358H13.5398C12.6351 7.3358 11.7688 6.95985 11.1286 6.28837C10.4903 5.61891 10.13 4.70819 10.13 3.75927C10.13 2.81236 10.4903 1.90165 11.1286 1.23017C11.7688 0.560697 12.6351 0.182739 13.5398 0.182739Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2003_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5398 0.182739H36.9998C37.9025 0.182739 38.7708 0.560698 39.4109 1.23017C40.0492 1.90165 40.4095 2.81236 40.4095 3.75927C40.4095 4.70819 40.0492 5.61891 39.4109 6.28838C38.7708 6.95986 37.9025 7.3358 36.9998 7.3358H13.5398C12.6351 7.3358 11.7688 6.95986 11.1286 6.28838C10.4903 5.61891 10.13 4.70819 10.13 3.75927C10.13 2.81236 10.4903 1.90165 11.1286 1.23017C11.7688 0.560698 12.6351 0.182739 13.5398 0.182739Z",
    stroke: "black",
    strokeWidth: 5
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3907 28.6334V32.7105H0.374023V29.4697L11.6747 15.1716H0.61169V11.0945H17.946V14.3353L6.67602 28.6334H18.3907Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.296 11.093V32.709H46.3784L36.105 19.585V32.709H31.3977V11.093H35.3384L45.5887 24.217V11.093H50.296Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2003_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 9,
    width: 9,
    height: 26
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1835 9.99756H29.2795V34.6533H21.1835V9.99756Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2003_216)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2003_216",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 9,
    width: 9,
    height: 26
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2794 14.2034V30.3651C29.2794 32.6891 27.4835 34.5709 25.2698 34.5709C23.0541 34.5709 21.2582 32.6891 21.2582 30.3651V14.2034C21.2582 11.8813 23.0541 9.99756 25.2698 9.99756C27.4835 9.99756 29.2794 11.8813 29.2794 14.2034Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2003_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2794 14.2034V30.3651C29.2794 32.6891 27.4835 34.5709 25.2698 34.5709C23.0541 34.5709 21.2582 32.6891 21.2582 30.3651V14.2034C21.2582 11.8813 23.0541 9.99756 25.2698 9.99756C27.4835 9.99756 29.2794 11.8813 29.2794 14.2034Z",
    stroke: "black",
    strokeWidth: 5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2003_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalLogo);
export default __webpack_public_path__ + "static/media/personal_logo.f64c47c72860adfc3f5e2c670b3cf834.svg";
export { ForwardRef as ReactComponent };